import { Permission } from "./permission";

export class Profile {
	id: number;
	name: string;
	description: string;
	permissions: Permission[];

	constructor(
		options: {
			id?: number;
			name?: string;
			description?: string;
			permissions?: Permission[];
		} = {}
	) {
		this.id = options.id;
		this.name = options.name;
		this.description = options.description;
		this.permissions = options.permissions || [];
	}
}
